import { grey } from '@mui/material/colors';
import { DASHBOARD_THEME_COLORS } from 'modules/dashboard/constants/dashboard-colors';
import { ICoverageListItem } from '../interfaces/IReportInventoryCoverage';

export enum COVERAGE_STATUS {
  OUT_OF_STOCK = '0',
  CRITICAL = '1-7',
  WARNING = '8-15',
  GOOD = '16-30',
  EXCELLENT = '31-90',
  OVERSTOCKED = '+90',
}

export const COVERAGE_STATUS_COLORS: Record<COVERAGE_STATUS, string> = {
  [COVERAGE_STATUS.OUT_OF_STOCK]: grey[800],
  [COVERAGE_STATUS.CRITICAL]: DASHBOARD_THEME_COLORS.DANGER_COLOR,
  [COVERAGE_STATUS.WARNING]: DASHBOARD_THEME_COLORS.WARNING_COLOR,
  [COVERAGE_STATUS.GOOD]: DASHBOARD_THEME_COLORS.SUCCESS_COLOR,
  [COVERAGE_STATUS.EXCELLENT]: DASHBOARD_THEME_COLORS.COUNT_COLOR,
  [COVERAGE_STATUS.OVERSTOCKED]: '#9c27b0',
};

export const getCoverageStatus = (data: ICoverageListItem): COVERAGE_STATUS => {
  if ((data?.coverageDays === null && data?.stockEod === 0) || data?.coverageDays === 0) return COVERAGE_STATUS.OUT_OF_STOCK;
  if (data?.coverageDays > 0 && data?.coverageDays <= 7) return COVERAGE_STATUS.CRITICAL;
  if (data?.coverageDays > 7 && data?.coverageDays <= 15) return COVERAGE_STATUS.WARNING;
  if (data?.coverageDays > 15 && data?.coverageDays <= 30) return COVERAGE_STATUS.GOOD;
  if (data?.coverageDays > 30 && data?.coverageDays <= 90) return COVERAGE_STATUS.EXCELLENT;
  return COVERAGE_STATUS.OVERSTOCKED;
};
